import { graphql } from 'react-relay';

export const homeFundIntroductionSectionFragment = graphql`
    fragment HomeFundIntroductionSection_pageSection on HomeFundIntroduction {
        title
        titleImageUrl
        titleImageBackgroundUrl
        anchorName
        versions {
            country
            text
            subTitle
            subText
            quote
            link1 {
                ...SimpleLink_simpleLink
            }
            link2 {
                ...SimpleLink_simpleLink
            }
        }
    }
`;
